import React, { Component } from 'react';
import Modal from '../../../components/Modal';
import StagesManager from '../../../components/StagesManager';
import ButtonAnimated from '../../../components/buttons/ButtonAnimated';
import { checkTranslation, translate } from '../../../utils/useful';
import HttpServices from '../../../utils/Http.services';
import PermissionsView from '../../../components/PermissionsView';

class AppletPermissionsView extends Component {

    state = {
        shareOptions: [
            { key: 'appletAccess', title: '{{lang}}Anyone with Applet Access ', access: '{{lang}}can view', icon: '/assets/icons/applets/drive/2peoples.svg', },
            { key: 'restricted', title: '{{lang}}Restricted ', access: '', icon: '/assets/icons/applets/drive/earth.svg', },
        ],
        // shareOptions: [
        //     // { key: 'collaborators', title: '{{lang}}Only collaborators of the document can access via link', icon: '/assets/icons/applets/drive/2peoples.svg', },
        //     // { key: 'organizationView', title: '{{lang}}People in the organization with the link ', access: '{{lang}}can view', icon: '/assets/icons/applets/drive/organization.svg', },
        //     // { key: 'organizationEdit', title: '{{lang}}People in the organization with the link ', access: '{{lang}}can edit', icon: '/assets/icons/applets/drive/organization.svg', },
        //     { key: 'appletAccess', title: '{{lang}}Anyone with Applet Access ', access: '{{lang}}can view', icon: '/assets/icons/applets/drive/earth.svg', },
        //     { key: 'restricted', title: '{{lang}}Restricted ', access: '', icon: '/assets/icons/applets/drive/earth.svg', },
        //     // { key: 'AnyoneEdit', title: '{{lang}}Anyone with the link ', access: '{{lang}}can edit', icon: '/assets/icons/applets/drive/earth.svg', },
        // ],
        currentShare: 0,
        headers: [
            { type: 'GlobalUserMultiInput', key: 'allowed', information: { address: 'searchUser', filter: {}, helperKey: 'hub._id', fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Add Users', required: false, } },
        ],
        headersLink: [
            { type: 'GlobalUserMultiInput', key: 'link', information: { address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Add Users', required: false, } },
            { type: 'SelectInput', key: 'applet', information: { isSearchable: true, label: '{{lang}}Applet', address: 'getMyFramesByType', filter: { features: 'Drive' }, fields: { title: 'applet.name', value: '_id' }, type: 'api', root: null, placeholder: '{{lang}}Select applet', required: false } },
        ],
        headersNotif: [
            { type: 'TextAreaInput', key: 'notif', information: { placeholder: '{{lang}}Add a note (Message will be sent to Yonnect messenger)', required: false, disabled: false } },
        ],
        qrCodeLink: '',
        link: '',
        showYonnect: false,
        showQRCode: false,
        notif: true
    }

    componentDidMount() {
        // console.log('mylink',this.props.currentItem)
        // this.props.setLink(this.props.currentItem)
        this.init()
    }


    componentDidUpdate(prevProps) {
        // if (this.props.admins && JSON.stringify(this.props.admins) != JSON.stringify(prevProps.admins)) {
        //     this.init()
        // }
    }


    updatePermissions = () => {
        this.setState({ isLoading: true })
        // TO DO:
        HttpServices.request('updateHubsettingPermissions', { applet: this.props.variables.appletId, permissions: { admins: this.state.admins } }, (fetchResult, fetchError) => {
            this.setState({ isLoading: false })
            if (fetchError) {

            }
        })
    }




    init = () => {

        // TO DO: fetch applet permissions
        HttpServices.request('getAppletPermissions', { applet: this.props.variables.appletId }, (fetchResult, fetchError) => {
            if (fetchError) {
                console.log('fetchError', fetchError)
                switch (fetchError?.key) {
                    case 'permissionDenied':
                        this.stageManager.changeStage('permissionDenied')
                        break;
                    default:

                        break;
                }
                return
            }
            this.setState({ admins: fetchResult.info })
        })
    }


    setAdmins = (admins, cb) => {
        this.setState({ admins }, () => {
            if (cb) {
                cb()
            }
        })
    }

    render() {

        return (
            <div className="w-100 br-10" style={{ backgroundColor: "#fff", overflow: 'hidden' }} >

                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >
                    <div className="" stage={0} stageName={'init'}>
                        <div>
                            <div className="pb-1 pt-1 px-3  flexcb top-0" style={{ position: 'sticky', backgroundColor: '', borderBottom: '1px solid #eee' }}>
                                <p className="mt-0 text-normal text-bold">{translate('Frame permissions')}</p>

                                <ButtonAnimated
                                    // iconwidth='24px'
                                    onClick={() => { this.updatePermissions() }}
                                    title={translate('Submit')}
                                    icon='/assets/icons/save.svg'
                                    textColor={'#fff'}
                                    invert={!this.props.colors?.iconInvert}
                                    bg={"#5856d6"}
                                    isLoading={this.state.isLoading}
                                />
                            </div>

                            <div className='px-2'>
                                <PermissionsView maxWidth={650} width={this.props.width} admins={this.state.admins} setAdmins={this.setAdmins} applet={false} defaultOpen={false} variables={this.props.variables} frames={this.props.frames} type={"frame"} permissionsType={'hubsetting'} hideOtherRolesText={true} />
                            </div>
                        </div>
                    </div>
                    <div stage={1} stageName='permissionDenied' className='flexcc' style={{ minHeight: '100px' }}>
                        <p>permissionDenied</p>
                    </div>
                </StagesManager>

            </div>

        );
    }
}

export default AppletPermissionsView;